export default "__VITE_ASSET__B66m7U$g__"